import React from 'react';

import { FaTelegramPlane } from 'react-icons/fa';

const Data = () => {
  return (
    <div className="home__data">
        <h1 className="home__title">
            Ewerton Lopes
        </h1>
        <h3 className="home__subtitle">Frontend Developer</h3>
        <p className="home__description">
        Frontend Developer passionate about building modern, responsive, and user-friendly applications. Skilled in <strong>React and NextJs</strong>, I turn complex ideas into simple, intuitive digital experiences. Focused on clean code, creativity, and delivering real value to users.
        </p>
        <a href="#contact" className="button">Let´s Talk!
        <FaTelegramPlane className='btn__icon'/>
        </a>
    </div>
  );
};

export default Data;